// Libraries
var React = require('react');
var $ = require('jquery');

// Components
var RelatedStoriesTitle = require('./RelatedStoriesTitle');
var RelatedStoriesItem = require('./RelatedStoriesItem');
var LoadMore = require('../../common/LoadMore/LoadMore');

// Styles
require('./RelatedStoriesModule.scss');

// Assets
var triangle = require('images/triangle_gray.svg');
var spinner = require('../../common/images/Rolling.svg');

class RelatedStoriesModule extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingMore: false
		}

		this.img = [];
		this.bg = [];
	}

	componentWillMount () {
		this.setState(this.props.data);
	}

	loadMore = () => {
		this.setState({ isLoadingMore: true });

		$.ajax({
			method: "GET",
			url: this.state.showMoreLink.url
		})
			.done(data => {
				if (typeof data.total !== "undefined" && data.total > 0) {
					this.setState({
						relatedContent: this.state.relatedContent.concat(data.relatedContent),
						showMoreLink: data.showMoreLink,
						isLoadingMore: false
					}, () => {
						window.LazyLoad.concat();

						if (window.AppUrlModifier) {
							window.AppUrlModifier.append();
						};
					});
				} else {
					this.setState({
						showMoreLink: null,
						isLoadingMore: false
					});
				}
			})
			.fail(() => {
				this.setState({
					showMoreLink: null,
					isLoadingMore: false
				});
			});
	};

	render() {
		return (
			<div className="RelatedStories">
				<div className="RelatedStories__background">
					<div className="RelatedStories__chevron">
						<div className="RelatedStories__triangle--left"><img src={triangle} alt="" /></div>
						<div className="RelatedStories__triangle--right"><img src={triangle} alt="" /></div>
					</div>
					<div className="RelatedStories__colour" />
				</div>

				<RelatedStoriesTitle heading={this.state.heading} />

				<div className="RelatedStories__container">
					{this.state.relatedContent.map((item, index) => {
						return (
							<RelatedStoriesItem key={index} {...item} />
						);
					})}
				</div>


				{!this.state.isLoadingMore && this.state.showMoreLink &&
						<LoadMore handle={this.loadMore} caption={this.state.showMoreLink.caption} context="related stories"/>
				}

				{this.state.isLoadingMore &&
						<img src={spinner} className="spinner" alt="Loading animation" />
				}
			</div>
		)
	}
}

module.exports = RelatedStoriesModule;



// WEBPACK FOOTER //
// ./src/components/RelatedStories/RelatedStoriesModule.js